/** Активный lockup логотипа на сайте (храниться в SiteSetting). */

export const BRAND_LOGO_VARIANT_IDS = ["n", "asset"] as const;

export type BrandLogoVariantId = (typeof BRAND_LOGO_VARIANT_IDS)[number];

/** Концепт N — бирюзовая А (откат). Дефолт — ассет брендбука. */
export const DEFAULT_BRAND_LOGO_VARIANT: BrandLogoVariantId = "asset";

export const BRAND_LOGO_SETTING_KEY = "brand.logoVariant";

export type BrandLogoVariantMeta = {
  id: BrandLogoVariantId;
  title: string;
  description: string;
  /** Превью в админке: путь к SVG или «react» для концепта N. */
  preview: "react-n" | { logo: string; icon: string };
};

export const BRAND_LOGO_VARIANTS: BrandLogoVariantMeta[] = [
  {
    id: "n",
    title: "Концепт N — бирюзовая А",
    description:
      "FacetedCapitalA + ИдеАлитика. Откат, если ассет брендбука не подходит.",
    preview: "react-n",
  },
  {
    id: "asset",
    title: "Ассет маркетолога — красная А (дефолт)",
    description:
      "SVG из public/brand/logo — фирменный lockup брендбука.",
    preview: {
      logo: "/brand/logo/logo.svg",
      icon: "/brand/logo/icon.svg",
    },
  },
];

export function isBrandLogoVariantId(
  value: string,
): value is BrandLogoVariantId {
  return (BRAND_LOGO_VARIANT_IDS as readonly string[]).includes(value);
}

export function parseBrandLogoVariantId(
  value: string | null | undefined,
): BrandLogoVariantId {
  if (value && isBrandLogoVariantId(value)) return value;
  return DEFAULT_BRAND_LOGO_VARIANT;
}

/** Favicon / знак для вкладки браузера по активному lockup. */
export function getBrandIconPath(variant: BrandLogoVariantId): string {
  return variant === "asset"
    ? "/brand/logo/icon.svg"
    : "/brand/logo-n/icon.svg";
}

/** Cache-bust, чтобы браузер не держал старый favicon. */
export function getBrandIconHref(variant: BrandLogoVariantId): string {
  return `${getBrandIconPath(variant)}?v=${variant}`;
}
